import React from 'react';
import { connect } from 'react-redux';
import EquipByNameView from './EquipByNameView';
import {
  getFilteredEquipmentForBuilding,
  getEquipmentByFloor,
} from '../../../redux/selectors/equipment';
import { getSearchParams } from '../../../utils/url';
import EquipByFloorView from './EquipByFloorView';
import { compareByNumericProp } from '../../../utils/comparators';

const mapStateToProps = (state, ownProps) => ({
  filteredEquipment: getFilteredEquipmentForBuilding(
    state,
    getSearchParams(ownProps.location.search)
  ),
  filteredEquipmentByFloor: getEquipmentByFloor(state, getSearchParams(ownProps.location.search)),
  byLocDisplayOption: state.ui.byLocDisplayOption,
});

const mapEquipToArray = (byFloor) => {
  const equipArray = [];
  const floorNames = Object.getOwnPropertyNames(byFloor);
  for (let i = 0; i < floorNames.length; i += 1) {
    const floorName = floorNames[i];
    equipArray.push({
      floorNum: byFloor[floorName].floorNum,
      name: floorName,
      sortOrder: byFloor[floorName].sortOrder,
      equipment: byFloor[floorName].equipment,
    });
  }
  equipArray.sort(compareByNumericProp('sortOrder', 'desc'));
  return equipArray;
};

const EquipmentContainer = (props) => {
  const { location, navigate } = props;
  const handleEquipSelection = (e, equipId) => {
    const url = `${location.pathname}/asset/${location.search}&eid=${equipId}`;
    navigate(url);
  };
  if (props.byLocDisplayOption === 'physlocation' || props.byLocDisplayOption === 'areaserved') {
    return (
      <EquipByFloorView
        equipmentByFloor={mapEquipToArray(props.filteredEquipmentByFloor)}
        handleEquipSelection={(e, equipId) => handleEquipSelection(e, equipId)}
      />
    );
  }
  return (
    <EquipByNameView
      equipmentByName={props.filteredEquipment}
      handleEquipSelection={(e, equipId) => handleEquipSelection(e, equipId)}
    />
  );
};

export default connect(mapStateToProps)(EquipmentContainer);
